import { makeVerification } from './makeVerification';

export const verifyReadBudgetUI = makeVerification('read_budget_ui');
export const verifyReadBudgets = makeVerification('read_member_budgets');
export const verifyReadBudgetHours = makeVerification(
  'read_member_budget_hours'
);
export const verifyUpdateBudgets = makeVerification('edit_member_budgets');
